module.exports = __webpack_public_path__ + "img/2d4f36bd15dd012c33b6885979ab5b5e.png";